var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountIcon',{attrs:{"image-url":_vm.imageUrl,"size":40}})}
var staticRenderFns = []

export { render, staticRenderFns }